export default __webpack_public_path__ + "static/media/right_hero.a7eb3b2a.png";